<template>
  <v-container>
    <template v-if="$store.getters.loadedSpeaker">
      <v-row justify="center">
        <v-col cols="3">
          <v-img src="@/assets/speaker.png"></v-img>
          <v-card-title>{{ speaker.firstName + ' ' + speaker.lastName }}</v-card-title>
          <v-card-subtitle>{{ speaker.bio }}</v-card-subtitle>
          <v-card-subtitle class="mt-n8">{{ speaker.publicEmail }}</v-card-subtitle>
        </v-col>
        <v-col cols="7">
          <v-card>
            <v-subheader>Баллы по невербалике</v-subheader>
            <v-sparkline
              :value="value"
              auto-draw
              color="#1f51a4"
              :lineWidth="2"
              :labelSize="10"
              :radius="10"
              :padding="20"
              show-labels
              :labels="value"
            >

            </v-sparkline>
          </v-card>
          <v-card class="mt-8">
            <v-subheader>Баллы по речи</v-subheader>
            <v-sparkline
              :value="value"
              auto-draw
              color="#ec1946"
              :lineWidth="2"
              :labelSize="10"
              :radius="10"
              :padding="20"
              show-labels
              :labels="value"
            >

            </v-sparkline>
          </v-card>
          <v-card class="mt-8">
            <v-subheader>Баллы по слайдам</v-subheader>
            <v-sparkline
              :value="value"
              auto-draw
              color="#1f51a4"
              :lineWidth="2"
              :labelSize="10"
              :radius="10"
              :padding="20"
              show-labels
              :labels="value"
            >

            </v-sparkline>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="3">

        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
export default {
  name: 'Profile',
  data () {
    return {
      value: [20, 23, 30, 28, 35, 38, 40]
    }
  },
  computed: {
    speaker: ({ $store }) => {
      return $store.getters.speaker
    }
  }
}
</script>

<style scoped>

</style>
